export enum ScanMode {
  Individual,
  Continuous,
}
